import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/Icon';
import { Input } from 'components/Input';
import './styles.scss';


const SearchInput = (props) => {
  return (
    <div className="search-input">
      <Icon.Bp icon="search" />
      <Input type="text" value={props.value} placeholder={props.placeholder} onChange={props.onChange} />
    </div>
  );
}


SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string
};

SearchInput.defaultProps = {
  value: '',
  onChange: ()=>{},
  placeholder: 'Search...'
};



export { SearchInput };
